/**
 * Request header carrying the per-user WorkDocs OAuth access token. Shared by the WorkDocs
 * proxy calls in `src/services/WorkDocsService.ts` and the org-run submit in
 * `src/api/baseball-card-service.ts`, so it lives here rather than in either caller.
 *
 * The token was moved off the `?token=` query param and out of the request body so it is
 * never written to API Gateway access logs (Shepherd d242539e, ROC14, CWE-522). Every API
 * Gateway that receives this header must list this exact name in its CORS `allowHeaders`
 * or the browser preflight blocks the request before it is sent. NOT `Authorization` —
 * SigV4 owns that header on `execute-api` calls, and Amplify drops SigV4 signing entirely
 * if it sees one.
 */
export const WORKDOCS_TOKEN_HEADER = 'X-WorkDocs-Token';
